import { useQuery } from "@apollo/client";
import { Box, Typography } from "@mui/material";
import { GetCurrentUserInfoDocument } from "../../generated";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Countdown from "react-countdown";
import { useEffect, useState } from "react";
import { IconButton } from "../Drawer/style";
import { DeleteIcon } from "../Icons/DeleteIcon";
import { CloseIcon } from "../Icons/CloseIcon";

export const TrialBanner = ({ workspaceId }: { workspaceId: string }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(true);
  const [expired, setExpired] = useState(false);
  const token = localStorage.getItem("token");
  const { data, loading } = useQuery(GetCurrentUserInfoDocument, {
    skip: !token && !workspaceId,
  });

  const renderer = ({ days, hours, minutes, seconds, completed }: any) => {
    if (completed) {
      navigate(`/workspace/${workspaceId}/trial-expired`);
      setExpired(true);
      return null;
    } else {
      // Render a countdown
      if (days)
        return (
          <span>
            going to expire in <strong>{days}</strong> Days,{" "}
            <strong>{hours}</strong> Hours, <strong>{minutes}</strong>{" "}
            Minutes
          </span>
        );

      return (
        <span>
          going to expire in <strong>{hours}</strong> Hours,{" "}
          <strong>{minutes}</strong> Minutes, <strong>{seconds}</strong> Seconds
        </span>
      );
    }
  };

  if (!workspaceId || loading) return null;

  return (
    <>
      {show && data?.currentUser.organization?.isTrial && (
        <Box
          style={{
            justifyContent: "center",
            textAlign: "center",
            background:
              "linear-gradient(to right, rgb(254, 190, 45), rgb(255, 229, 169), rgb(254, 190, 45))",
            color: "rgb(5, 82, 78)",
            position: "fixed",
            left: 0,
            top: 0,
            right: 0,
            zIndex: "9999",
            padding: "10px 0",
          }}
        >
          <Box display="flex" justifyContent={"center"}>
            <Typography>
              Trial is{" "}
              {expired ? (
                <strong>expired</strong>
              ) : (
                <Countdown
                  date={
                    new Date(
                      data?.currentUser?.organization?.trialEndDate || ""
                    )
                  }
                  renderer={renderer}
                />
              )}
            </Typography>
            <IconButton
              onClick={() => setShow(false)}
              sx={{
                position: "absolute",
                right: 0,
                top: 0,
                color: "rgb(5, 82, 78)",
                svg: {
                  width: "32px !important",
                  height: "32px !important",
                },
              }}
            >
              <CloseIcon width={32} height={32} />
            </IconButton>
          </Box>
        </Box>
      )}
    </>
  );
};
